
export const WorldWideOption = {
    Default: 'Default',
    Worldwide: 'Worldwide'
}